import * as React from 'react';

import { Price16 } from '@cian/ui-kit/icons';
import * as styles from './styles.css';

export const DiffDown: React.FC = () => {
  return (
    <div className={styles['price-diff-arrow']}>
      <Price16 color="success_100" display="block" />
    </div>
  );
};

DiffDown.displayName = 'DiffDown';
